<template>
  <div>
      <b-form>
        <FormulateInput
            v-model="formValues"
            class="mt-3"
            :label="label"
            :name="name"
            type="group"
            validation-name="Student address"
            :validation="[
              ['^required'],
              ['address'],
            ]"
            :validation-rules="{ 
              address: addressRule,
            }"
            :validation-messages="{ address: addressMessage }"
            id="address"
            :value="defaultValue"
        >
        <b-row>
            <b-col xs=12 md=5>
                <FormulateInput
                    name="street"
                    placeholder="Street"
                    v-model="street"
                />
            </b-col>
            <b-col sm=5 md=3>
            <FormulateInput
                name="city"
                placeholder="City"
            />
            </b-col>
          <b-col sm=4 md=2>
            <FormulateInput
              type="select"
              name="state"
              :options="states"
              value="MN"
              placeholder="State"
            />
          </b-col>
          <b-col sm=3 md=2> 
            <FormulateInput
              name="zip_code"
              placeholder="Zip Code"
            />
          </b-col>
          </b-row>
        </FormulateInput>
    </b-form>
  </div>
</template>
<script>
import DropdownLists from './DropdownLists.json'
    export default {
        name: "AddressValidation",
        data() {
            return {
                query: "",
                formValues: {},
                selected: null,
                street: "",
                houseNumber: "",
                states: DropdownLists.states,
                allFilled: '',
            };
        },
        props: {
          name: String,
          label: String,
          defaultValue: [],
        },
        methods: {
          addressRule ({ value }) {
              if (Array.isArray(value)) {
                  let street = this.street ? this.street.split(' ') : [];
                  this.houseNumber = street.shift();
                  // this.streetName = street.join(" "); // convert the rest of street array to string seperated by space
                  const [address] = value
                  this.allFilled = address.street && address.city && address.state && address.zip_code;
                  return this.allFilled;
              }
          },
          addressMessage ({ value }) {
              if (!this.isValid) 
                  return 'Please fill out valid address.'
              if (Array.isArray(value)) {
                  const [address] = value
                  const missing = ['street', 'city', 'state', 'zip_code'].reduce((missing, field) => {
                      if (!address[field]) {
                          missing.push(field)
                      }
                      return missing
                  }, [])
                  return `Please fill out valid ${missing.join(', ')} field.`
              }
              return 'Please fill out address.'
          },
          setDefaultAddress () {
              this.formValues =  this.defaultValue ? this.defaultValue : ''
          },
        },
        mounted() {
          this.setDefaultAddress ()
        },
    }
</script>

<style>
.form-control:not(textarea)  {
    height: calc(2.1em + 0.5rem + 2px) !important;
}

.d-center {
  display: flex;
  align-items: center;
}

.v-select .dropdown li {
  border-bottom: 1px solid rgba(112, 128, 144, 0.1);
}

.v-select .dropdown li:last-child {
  border-bottom: none;
}

.v-select .dropdown li a {
  padding: 10px 20px;
  width: 100%;
  font-size: 1.25em;
  color: #3c3c3c;
}

.v-select .dropdown-menu .active > a {
  color: #fff;
}


</style>